import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CalibrantLoadModule } from "../../calibrant-load/calibrant-load.module";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { GaChartComponent } from './ga-chart.component';

library.add(faExclamationTriangle);

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FontAwesomeModule,
    CalibrantLoadModule
  ],
  declarations: [
    GaChartComponent
  ],
  exports: [
    GaChartComponent
  ]
})
export class GaChartModule { }
